var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.7143 16.8571L21.4286 14H25.7143L26.4286 16.8571M32.1429 16.8571H16.4286L17.8571 34H29.2857L30.7143 16.8571H15H32.1429ZM23.5714 21.1429V29.7143V21.1429ZM27.1429 21.1429L26.4286 29.7143L27.1429 21.1429ZM20 21.1429L20.7143 29.7143L20 21.1429Z","stroke":"#EB5757","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Remove.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Remove;

Remove.default = Remove;
